import { get, put } from "../utils/request";

const requestList = {
  getDevice: "/xxy/basic/deviceType/getInfo",
  getDeviceList: "/xxy/basic/device/getInfo",
  getDeviceAll: "/xxy/device/monitor/listDevice",
  getAllConfig: "/xxy/device/config/listAll",

  /* -------------点检 && 保养--------------- */
  /* 库 */
  getMaintain: "/xxy/device/config/list", // 获取库
  singleRemove: "/xxy/device/config/remove",
  saveMaintain: "/xxy/device/config/save",
  getServeInfo: "/xxy/device/config/getInfo",

  /* 方案 */
  getScheme: "/xxy/device/configPath/list",
  batchDelSchema: "/xxy/device/configPath/batchRemove",
  delSchema: "/xxy/device/configPath/remove",
  saveSchema: "/xxy/device/configPath/save",
  schemaInfo: "/xxy/device/configPath/getInfo",

  /* 计划 */
  getPlan: "/xxy/device/configPlan/list",
  savePlan: "/xxy/device/configPlan/save",
  delPlan: "/xxy/device/configPlan/remove",
  batchDelPlan: "/xxy/device/configPlan/batchRemove",
  getPlanInfo: "/xxy/device/configPlan/getInfo",
  toDetail: "/xxy/device/configPlan/save",
  getDeviceByType: "/xxy/basic/device/listByTypeId",
  getSchemaByType: "/xxy/device/configPath/listByTypeId",
  recoverPlan: "/xxy/device/configPlan/remove", //回收计划

  /* 操作 */
  getDeviceByOp: "/xxy/basic/device/listByType",
  getOperateList: "/xxy/device/configTask/list",
  getListByConfigs: "/xxy/device/configPath/getDetailInfo", //弹窗内获取列表数据
  saveOperate: "/xxy/device/configTask/save",

  /* 查询 */
  getQuery: "/xxy/device/configTask/list",
  getResultInfo: "/xxy/device/configTask/getInfo",

  /* ------------设备监控------------- */
  getMonitor: "/xxy/device/monitor/list",
  getMonitorDetail: "/xxy/device/monitor/getDeviceDetail",
  getMonitorParams: "/xxy/device/monitor/listDeviceParamValue",

  /* 设备日志 */
  getDeviceLog: "/xxy/device/maintainRecord/listNew",

  /* ------------工具---------------- */
  getMould: "/xxy/mould/mould/listAll"
};

export function gets(type) {
  return async function(data, options) {
    return await get(requestList[type], data, options);
  };
}
export function posts(type) {
  return async function(data, options) {
    return await put(requestList[type], data, options);
  };
}
